import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Hook to fetch CMS content for a page
 * @param {string} slug - Page slug (e.g., 'home', 'about', 'contact')
 * @returns {{ content: object, seo: object, loading: boolean, error: string }}
 */
export const useCMSContent = (slug) => {
  const [content, setContent] = useState({ sections: [], seo: {} });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/pages/${slug}/content`);
        setContent({
          sections: response.data.sections || [],
          seo: response.data.seo || {}
        });
      } catch (err) {
        console.error(`Failed to fetch CMS content for ${slug}:`, err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchContent();
    }
  }, [slug]);

  return { content, sections: content.sections, seo: content.seo, loading, error };
};

/**
 * Get a specific section by ID from sections array
 */
export const getSection = (sections, sectionId) => {
  return sections?.find(s => s.id === sectionId) || null;
};

/**
 * Get section by type (returns first match)
 */
export const getSectionByType = (sections, type) => {
  return sections?.find(s => s.type === type) || null;
};

/**
 * Get all sections of a specific type
 */
export const getSectionsByType = (sections, type) => {
  return sections?.filter(s => s.type === type) || [];
};

export default useCMSContent;
